class StickyBuyBar extends HTMLElement {
  constructor() {
    super();
    console.log('StickyBuyBar constructor called');
    this.stickyCart = this;
    this.stickyProductImage = this.querySelector('.sticky-product-image img');
    this.stickyProductOptions = this.querySelector('.sticky-product-options');
    this.stickyPriceValue = this.querySelector('.sticky-price-value');
    this.stickyPriceText = this.querySelector('.sticky-price-text');
    this.stickyPriceDiscountText = this.querySelector('.sticky-price-discount-text');
    this.stickyCtaButton = this.querySelector('.sticky-cta-button');
    this.mainCtaButton = document.querySelector('#ajaxAtcBtn');
    this.deliveryText = this.getAttribute('delivery-text') || '';
    this.deliveryDefaultText = this.getAttribute('delivery-default-text') || '';

    this.isStickyVisible = false;

    this.updateStickyCart = this.updateStickyCart.bind(this);
    this.toggleStickyCart = this.toggleStickyCart.bind(this);
    this.updateStickyProductImage = this.updateStickyProductImage.bind(this);

    window.addEventListener('scroll', this.toggleStickyCart);
    window.addEventListener('resize', () => {
      this.isStickyVisible = false;
      this.stickyCart.classList.remove('show');
      document.body.classList.remove('sticky-cart-visible');
      setTimeout(this.toggleStickyCart, 100);
    });

    this.observeChanges();
    this.stickyCtaButton.addEventListener('click', () => {
      if (!this.stickyCtaButton.disabled && this.mainCtaButton) {
        this.mainCtaButton.click();
      }
    });

    setTimeout(this.updateStickyCart, 500);
    this.updateStickyProductImage();
    setTimeout(this.toggleStickyCart, 100);
  }

  updateStickyCart() {
    const selectedOfferType = document.querySelector('.selector-choice.active .selector-heading')?.textContent || '';
    const selectedProgram = document.querySelector('.selector-choice.active .name')?.textContent || '';
    const selectedDiscount = document.querySelector('.selector-choice.active .discount-container .discount')?.textContent || '';
    const selectedPrice = document.querySelector('.selector-choice.active .price')?.textContent || '';

    let optionsText = '';
    if (selectedOfferType) optionsText += `<span>${selectedOfferType}</span>`;
    if (selectedProgram) optionsText += `<span>${selectedProgram}</span>`;
    // Only show delivery text when subscription is selected
    const isSubscriptionActive = document.querySelector("#selectorTypeSubscription")?.classList.contains("active") &&
        !document.querySelector("#selectorTypeSubscription")?.classList.contains("disabled-choice");
    
    if (this.deliveryText && isSubscriptionActive) {
      optionsText += `<span class="sticky-delivery-text">
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 4H15.3373C15.5818 4 15.7041 4 15.8192 4.02763C15.9213 4.05213 16.0188 4.09253 16.1083 4.14736C16.2092 4.2092 16.2957 4.29568 16.4686 4.46863L20.5314 8.53137C20.7043 8.70432 20.7908 8.7908 20.8526 8.89172C20.9075 8.98119 20.9479 9.07873 20.9724 9.18077C21 9.29586 21 9.41815 21 9.66274V12.5C21 12.9659 21 13.1989 20.9239 13.3827C20.8224 13.6277 20.6277 13.8224 20.3827 13.9239C20.1989 14 19.9659 14 19.5 14M14.5 14H13M13 14V4.2C13 3.0799 13 2.51984 12.782 2.09202C12.5903 1.71569 12.2843 1.40973 11.908 1.21799C11.4802 1 10.9201 1 9.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.0799 1 4.2V12C1 13.1046 1.89543 14 3 14M13 14H9M9 14C9 15.6569 7.65685 17 6 17C4.34315 17 3 15.6569 3 14M9 14C9 12.3431 7.65685 11 6 11C4.34315 11 3 12.3431 3 14M19.5 14.5C19.5 15.8807 18.3807 17 17 17C15.6193 17 14.5 15.8807 14.5 14.5C14.5 13.1193 15.6193 12 17 12C18.3807 12 19.5 13.1193 19.5 14.5Z" stroke="#00A690" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        ${this.deliveryText}</span>`;
    } else {
      optionsText += `<span class="sticky-delivery-text">
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 4H15.3373C15.5818 4 15.7041 4 15.8192 4.02763C15.9213 4.05213 16.0188 4.09253 16.1083 4.14736C16.2092 4.2092 16.2957 4.29568 16.4686 4.46863L20.5314 8.53137C20.7043 8.70432 20.7908 8.7908 20.8526 8.89172C20.9075 8.98119 20.9479 9.07873 20.9724 9.18077C21 9.29586 21 9.41815 21 9.66274V12.5C21 12.9659 21 13.1989 20.9239 13.3827C20.8224 13.6277 20.6277 13.8224 20.3827 13.9239C20.1989 14 19.9659 14 19.5 14M14.5 14H13M13 14V4.2C13 3.0799 13 2.51984 12.782 2.09202C12.5903 1.71569 12.2843 1.40973 11.908 1.21799C11.4802 1 10.9201 1 9.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.0799 1 4.2V12C1 13.1046 1.89543 14 3 14M13 14H9M9 14C9 15.6569 7.65685 17 6 17C4.34315 17 3 15.6569 3 14M9 14C9 12.3431 7.65685 11 6 11C4.34315 11 3 12.3431 3 14M19.5 14.5C19.5 15.8807 18.3807 17 17 17C15.6193 17 14.5 15.8807 14.5 14.5C14.5 13.1193 15.6193 12 17 12C18.3807 12 19.5 13.1193 19.5 14.5Z" stroke="#00A690" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      ${this.deliveryDefaultText}</span>`;
    }

    this.stickyProductOptions.innerHTML = optionsText;
    if (selectedPrice) this.stickyPriceValue.textContent = selectedPrice;
    this.stickyPriceText.textContent = selectedDiscount || '';
    if (selectedProgram) this.stickyPriceDiscountText.textContent = selectedProgram;

    this.stickyCtaButton.disabled = !this.mainCtaButton || this.mainCtaButton.disabled;
    this.stickyCtaButton.textContent = this.mainCtaButton?.textContent || this.dataset.defaultCta || 'Buy now';
  }

  toggleStickyCart() {
    const originalButton = document.querySelector('.ds-cta');
    if (!originalButton) return;

    const buttonRect = originalButton.getBoundingClientRect();
    const scrollY = window.scrollY;
    const buttonTop = originalButton.offsetTop;
    const isMobile = window.innerWidth <= 767;

    const shouldShowSticky = scrollY > buttonTop && buttonRect.bottom < 0;

    if (shouldShowSticky && !this.isStickyVisible) {
      this.stickyCart.classList.add('show');
      document.body.classList.add('sticky-cart-visible');
      this.isStickyVisible = true;
    } else if (!shouldShowSticky && this.isStickyVisible) {
      this.stickyCart.classList.remove('show');
      document.body.classList.remove('sticky-cart-visible');
      this.isStickyVisible = false;
    }
  }

  updateStickyProductImage() {
    const activeFlavor = document.querySelector('.selector-flavor.active');
    if (activeFlavor) {
      const flavorType = activeFlavor.getAttribute('data-flavor');
      const slide = document.querySelector(`.swiper-slide[data-flavorslide="${flavorType}"] img`);
      if (slide && slide.src) {
        this.stickyProductImage.src = slide.src;
      }
    }
  }

  observeChanges() {
    const observer = new MutationObserver(() => {
      this.updateStickyCart();
      this.updateStickyProductImage();
    });

    const elements = document.querySelectorAll('.selector-choice, .selector-flavor, .selector-cup-choice, .total, #ajaxAtcBtn, .ds-type-selector');
    elements.forEach(el => observer.observe(el, { attributes: true, childList: true }));
  }
}

console.log('Defining sticky-buy-bar custom element');
customElements.define('sticky-buy-bar', StickyBuyBar);